var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66634 14.1323H3.33301C2.96482 14.1323 2.66634 13.8338 2.66634 13.4657V4.13232C2.66634 3.76413 2.96482 3.46566 3.33301 3.46566H6.66634C7.03453 3.46566 7.33301 3.16718 7.33301 2.79899C7.33301 2.4308 7.03453 2.13232 6.66634 2.13232H3.33301C2.22844 2.13232 1.33301 3.02775 1.33301 4.13232V13.4657C1.33301 14.5702 2.22844 15.4657 3.33301 15.4657H6.66634C7.03453 15.4657 7.33301 15.1672 7.33301 14.799C7.33301 14.4308 7.03453 14.1323 6.66634 14.1323Z",
    fill: "#495680"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8616 10.9943C10.6013 11.2546 10.6013 11.6767 10.8616 11.9371C11.122 12.1974 11.5441 12.1974 11.8044 11.9371L14.4711 9.27039C14.7314 9.01005 14.7314 8.58794 14.4711 8.32759L11.8044 5.66092C11.5441 5.40057 11.122 5.40057 10.8616 5.66092C10.6013 5.92127 10.6013 6.34338 10.8616 6.60373L13.0569 8.79899L10.8616 10.9943Z",
    fill: "#495680"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9997 8.13232H5.99967C5.63148 8.13232 5.33301 8.4308 5.33301 8.79899C5.33301 9.16718 5.63148 9.46566 5.99967 9.46566H13.9997C14.3679 9.46566 14.6663 9.16718 14.6663 8.79899C14.6663 8.4308 14.3679 8.13232 13.9997 8.13232Z",
    fill: "#495680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/iconLogout.f7878f1505acebca920f280f99f4c7ff.svg";
export { ForwardRef as ReactComponent };